/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
import React, { useMemo, useState } from 'react';

import { IDeliveryNote } from 'commons/types';
import { DNPrintTemplateComponent } from 'pages/delivery-note/dn-detail/print-components/DNPrintTemplate.component';

import { IInvoiceMappedData } from '../../interfaces';
import { InvoicePrintTemplateComponent } from '../invoice-template';

const InvoicePackPrintTemplate: React.FC = () => {
  document.body.className = 'print-template';
  const data: IInvoiceMappedData = useMemo(
    () => JSON.parse(localStorage.getItem('invoice') || ''),
    [],
  );
  const [dnPageBreak, setDnPageBreak] = useState<React.JSX.Element[]>([]);

  const setInvoiceMaxPageNumber = (pageNumber: number) => {
    // set dn page break
    const pageBreak: React.JSX.Element[] = [];
    for (let i = 0; i < pageNumber - 1; i++) {
      pageBreak.push(<div style={{ pageBreakAfter: 'always' }} />);
    }
    setDnPageBreak(pageBreak);
  };

  const deliveryNote: IDeliveryNote | null = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('delivery-note') || 'null');
    } catch {
      return null;
    }
  }, []);

  return (
    <>
      <InvoicePrintTemplateComponent
        data={data}
        setMaxPageNumber={setInvoiceMaxPageNumber}
      />
      {deliveryNote && (
        <>
          {dnPageBreak}
          <DNPrintTemplateComponent data={deliveryNote} />
        </>
      )}
    </>
  );
};

export default InvoicePackPrintTemplate;
